import { cva } from '@/styled-system/css';

export const inlineFeedbackLabelRecipe = cva({
  base: {
    textStyle: 'body',
  },
  variants: {
    tone: {
      critical: {
        color: 'InlineFeedback.critical.text',
      },
      info: {
        color: 'InlineFeedback.info.text',
      },
      success: {
        color: 'InlineFeedback.success.text',
      },
      transient: {
        color: 'InlineFeedback.transient.text',
        fontStyle: 'italic',
      },
      warning: {
        color: 'InlineFeedback.warning.text',
      },
    },
  },
});
